import React from "react";
const TextField = ({ field, label, onChange, ...rest }) => {
   const handleChange = (ev) => {
      let { name, value } = ev.target;
      console.log({ name, value });
      onChange && onChange({ name, value });
   };
   return (
      <div className='field'>
         <label htmlFor={field} className='pos-relative label'>
            {label}
            <input {...rest} name={field} id={field} onChange={handleChange} />
         </label>
      </div>
   );
};

export default TextField;
